"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsiteFastTagClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const WebsiteFastTagError_1 = require("./WebsiteFastTagError");
const WEBSITE_FAST_TAG_URL = process.env.WEBSITE_FAST_TAG_URL;
const WEBSITE_FAST_TAG_BASIC_AUTH_USER = process.env.WEBSITE_FAST_TAG_BASIC_AUTH_USER;
const WEBSITE_FAST_TAG_BASIC_AUTH_PASSWORD = process.env.WEBSITE_FAST_TAG_BASIC_AUTH_PASSWORD;
class WebsiteFastTagClient extends base_client_1.ApiBasicAuthClient {
    constructor(url = WEBSITE_FAST_TAG_URL, user = WEBSITE_FAST_TAG_BASIC_AUTH_USER, password = WEBSITE_FAST_TAG_BASIC_AUTH_PASSWORD) {
        super({
            baseURL: `${url}`,
            basicAuthPassword: password,
            basicAuthUser: user,
        });
        if (!user || !password) {
            commons_logs_1.log.warn("Missing WEBSITE_FAST_TAG_BASIC_AUTH_USER and WEBSITE_FAST_TAG_BASIC_AUTH_PASSWORD environment variables");
        }
    }
    async createSeller(sellerId) {
        try {
            return await this.put(`/v1/seller/${sellerId}`, undefined);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getAllSellers(limit, offset, filters = {}) {
        try {
            return await this.get(`/v1/sellers`, Object.assign({ limit,
                offset }, filters));
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async assignShippingRateOffer(orderId, orderTime, serviceLevel, dskus, zip) {
        try {
            await this.put("/v1/service-rate/offer", {
                orderId,
                orderTime,
                serviceLevel,
                dskus,
                zip,
            });
            return true;
        }
        catch (err) {
            if (err.response && err.response.data === WebsiteFastTagError_1.WebsiteFastTagError.SHIPPING_RATE_OFFER_NOT_FOUND) {
                return false;
            }
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async addNewProducts(newProductData) {
        try {
            return await this.post(`/v1/products`, newProductData);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getProducts(sellerId, dskus, createdSince, limit, offset) {
        try {
            return await this.get(`/v1/seller/${sellerId}/products`, {
                dskus,
                createdSince,
                limit,
                offset,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getProductMskus(sellerId, mskus, dskus = []) {
        try {
            return await this.get(`/v1/seller/${sellerId}/product-mskus`, {
                mskus,
                dskus,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async createWebsiteSeller(seller) {
        try {
            return await this.post("/v1/website/seller", seller);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.DUPLICATE_SELLER_ID]);
        }
    }
    async updateWebsiteSeller(sellerId, update) {
        try {
            return await this.put(`/v1/website/seller/${sellerId}`, update);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.NOT_FOUND]);
        }
    }
    async getWebsiteSeller(sellerId) {
        try {
            return await this.get(`/v1/website/seller/${sellerId}`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.NOT_FOUND]);
        }
    }
    async getAllWebsiteSellers(limit, offset, filters = {}) {
        try {
            return await this.get(`/v1/website/sellers`, Object.assign({ limit,
                offset }, filters));
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getServiceLevelCoverageForProduct(dsku) {
        try {
            return await this.get(`/v1/dsku/${dsku}/coverage/servicelevel`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.NOT_FOUND]);
        }
    }
    async getServiceLevelCoverageForWarehouses(warehouseIds) {
        try {
            return await this.get(`/v1/warehouses/coverage/servicelevel`, {
                warehouseIds,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getWarehouseCombinationsById(warehouseCombinationIds) {
        try {
            return await this.get(`/v1/warehouse-combinations`, { warehouseCombinationIds });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getWarehousesByDsku(sellerId, dskus) {
        try {
            return await this.get(`/v1/seller/${sellerId}/coverage/warehouses`, { dskus });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getCoverageWarehouseIdsByDsku(dskus) {
        try {
            return await this.get(`/v1/coverage/warehouseids`, { dskus });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getNationwideCoverageThreshold() {
        try {
            return await this.get("/v1/coverage/nationwide-threshold");
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getServiceLevels(address, dskus, mskus, sellerId, orderDate, dskusAndBundleDskus) {
        try {
            return await this.get(`/v1/service-level/zip/${address.zip}`, Object.assign(Object.assign({ dskus,
                mskus,
                sellerId,
                orderDate }, address), { dskusAndBundleDskus }));
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.MISSING_SELLER_ID]);
        }
    }
    async getServiceLevelsV2(address, dskus, mskus, sellerId, orderDate, dskusAndBundleDskus) {
        try {
            return await this.post(`/v2/service-level/zip/${address.zip}`, {
                dskus,
                skus: mskus,
                orderDate,
                sellerId,
                dskusAndBundleDskus,
            }, Object.assign({}, address));
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.MISSING_SELLER_ID]);
        }
    }
    async getStore(sellerId, storeName = sellerId) {
        try {
            return await this.get(`/v1/seller/${sellerId}/store/${storeName}`);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.NOT_FOUND]);
        }
    }
    async saveOrUpdateStore(sellerId, storeName = sellerId, storeData) {
        try {
            return await this.put(`/v1/seller/${sellerId}/store/${storeName}`, storeData);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [WebsiteFastTagError_1.WebsiteFastTagError.NOT_FOUND]);
        }
    }
    async saveOrUpdateShippingSetting(sellerId, storeName = sellerId, shippingSetting, settingData) {
        try {
            return await this.put(`/v1/seller/${sellerId}/store/${storeName}/shipping-setting/${shippingSetting}`, settingData);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [
                WebsiteFastTagError_1.WebsiteFastTagError.NOT_FOUND,
                WebsiteFastTagError_1.WebsiteFastTagError.INVALID_FT_SETTING,
                WebsiteFastTagError_1.WebsiteFastTagError.MISSING_SHIPPING_COST,
            ]);
        }
    }
    async getCoverageWarehouses(coverageWarehouseIds) {
        try {
            return await this.get("/v1/warehouses/coverage-warehouses", { coverageWarehouseIds });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getExperimentGroupAssignments(sellerId, storeName, randomizationUnitId) {
        try {
            return await this.get(`/v1/experiment/seller/${sellerId}/store/${storeName}/experiment-groups`, { randomizationUnitId });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getBadgeGlobalContext(sellerId, storeName, ipAddress, randomizationUnitId) {
        try {
            return await this.get(`/v1/seller/${sellerId}/store/${storeName}/badge-global-context`, {
                ipAddress,
                randomizationUnitId,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getSchedules(ids) {
        try {
            return await this.get("/v1/schedules", {
                ids,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getDeliveryPromisesForSchedule(scheduleId, cursor) {
        try {
            return await this.get(`/v2/schedule/${scheduleId}/delivery-promises`, {
                cursor,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getProductSchedules(accountId, cursor, limit) {
        try {
            return await this.get(`/v1/product-delivery-schedules`, { cursor, limit }, { "x-shopify-logistics-account-id": accountId });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getDeliveryScheduleEntries(scheduleId, cursor, limit) {
        try {
            return await this.get(`/v1/schedules/${scheduleId}/entries`, {
                cursor,
                limit,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async getDeliveryDetails(marketplaceOrderId, sellerId, marketplaceId, destinationAddress, dskus, tags, originalOrderCreationTime, listingSolutionId, destinationTz, promisedDeliveryTime, requiredDeliveryInDays, originalDestinationAddress) {
        try {
            return await this.post(`/v1/delivery-details`, {
                marketplaceOrderId,
                sellerId,
                marketplaceId,
                destinationAddress,
                dskus,
                tags,
                originalOrderCreationTime,
                listingSolutionId,
                destinationTz,
                promisedDeliveryTime,
                requiredDeliveryInDays,
                originalDestinationAddress,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
    async determineShippingRateOfferDetails(originalOrderCreationTime, dskus, address, marketplaceOrderId, marketplaceId, sellerId, shippingRateName) {
        try {
            return await this.post(`/v1/shipping-rate-offer-details`, {
                originalOrderCreationTime,
                dskus,
                address,
                marketplaceOrderId,
                marketplaceId,
                sellerId,
                shippingRateName,
            });
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
}
exports.WebsiteFastTagClient = WebsiteFastTagClient;
//# sourceMappingURL=WebsiteFastTagClient.js.map